import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import Tooltip from 'src/Components/Tooltip';
import { TooltipPosition } from 'src/Components/Tooltip/types';
import Button from 'src/Components/Button_V2';
import icInfo from 'assets/svg/ic_info_outlined_V2.svg';
import icArrowUp from 'assets/svg/ic_arrow_up_blue.svg';
import { formatCurrency } from '@wolffun/system-currency';

const HeroChoosing = ({
  numberSelected,
  chooseHero,
  thgPerHero
}) => {
  const [collapsed, setCollapsed] = React.useState(false);

  const renderTooltipHeroes = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.tooltip, styles.tooltipHeroes)
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.describe
    }, "Staking\xA0", formatCurrency(thgPerHero, {
      withCurrency: true,
      trimWholeFraction: true
    }), "\xA0requires 1 NFT Hero"), /*#__PURE__*/React.createElement("span", {
      className: styles.example
    }, "Ex: If you stake 10,000 THG, you need 100 NFT heroes"), /*#__PURE__*/React.createElement("div", {
      className: styles.note
    }, /*#__PURE__*/React.createElement("span", null, "Once NFT heroes are staked, they will be removed from your inventory permanently")));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.row
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header,
    onClick: () => setCollapsed(!collapsed)
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }, /*#__PURE__*/React.createElement("span", null, "Heroes"), /*#__PURE__*/React.createElement(Tooltip, {
    content: renderTooltipHeroes(),
    position: TooltipPosition.BOTTOM,
    color: "#3C32AF"
  }, /*#__PURE__*/React.createElement("img", {
    src: icInfo,
    className: styles.icInfo
  }))), /*#__PURE__*/React.createElement("span", {
    className: styles.value
  }, /*#__PURE__*/React.createElement("span", null, numberSelected, " Heroes"), /*#__PURE__*/React.createElement("img", {
    src: icArrowUp,
    className: classNames(styles.icArrow, collapsed && styles.collapsed)
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.content, collapsed && styles.collapsed, styles.fullWidth)
  }, /*#__PURE__*/React.createElement(Button, {
    title: "Choose Heroes",
    type: "outlined",
    className: classNames(styles.fullWidth, styles.btnChooseHero),
    onClick: chooseHero
  }), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles.fullWidth, styles.noticeSelected)
  }, "You selected ", /*#__PURE__*/React.createElement("span", null, numberSelected), " Heroes")));
};

export default HeroChoosing;